export default "__VITE_ASSET__0559111d__"